/* Tracking Scripts */
loadGTMScript('GTM-PDWZSMS');

/* PPC Tracking */
loadScriptCMM(
  '//cdn.rlets.com/capture_configs/7ea/723/b0d/ead401bb20018258ee5d359.js',
  null,
  {
    async: true,
  },
);

/* Google Ads Conversions */
loadGoogleAdsConversions({
  account: 'AW-783850909',
  enhanced_conversions: true,
  conversions: [
    {
      label: '5YnsCPHM9IkYEJ274vUC',
      selector: 'form_submission',
      trigger: 'lead',
      enhancedConversionMapping: true,
    },
    {
      label: 'gP-ICNGD9YkYEJ274vUC',
      adConversionType: 'directions',
    },
    {
      label: 'lFRxCLysh_cDEJ274vUC',
      phoneConversionNumber: '(978) 369-6165',
    },
  ],
});

/* Home Page Slider Logo */
deferJQuery(function () {
  if (strPath == '') {
    jQuery(document).ready(function () {
      jQuery('.slick-slide .background').append(
        '<div class="cmm-ssa-slide-logo"><img src="/AdminCenter/Library.Files/Media/1558/2017-SSA.png" alt="Angie\'s List 2017 Super Service Award" border="0" /></div>',
      );
    });
  }
});

/* Header Contact Banner */
CMMBanner.make(
  [
    {
      text: [
        {
          content:
            'Proudly serving Concord, Massachusetts (MA), and the surrounding areas',
        },
      ],
    },
    {
      text: CMMBanner.createSimpleButtons([
        CMMBanner.Button.Presets.DIRECTIONS({
          link: 'http://www.google.com/maps/search/?api=1&query=WTI+Window+Treatment+Installation+17+Beharrell+St+%2CConcord%2CMA+01742-2963',
        }),

        CMMBanner.Button.Presets.PHONE({
          link: 'tel:+19783696165',
        }),

        CMMBanner.Button.Presets.SMS({
          link: 'sms:+19786378669',
        }),
      ]),
    },
  ],
  {
    presets: [CMMBanner.Presets.HEADER_CONTACT],
  },
);

/* Smooth Scrolling */
cmmSmoothScrollInit();

/* Leave a Review Button */
if (['about/about-us'].includes(strPath)) {
  deferJQuery(function () {
    headerBannerMultipleColumns(
      [
        {
          text: "<a class='cmm-button cmm-leave-a-review' target='_blank' href='https://grow.creekmoremarketing.com/wti-inc--160458594150235/review-us?dashboard=1'>LEAVE A REVIEW</a>",
          bgColor: '#fff',
          linkColor: '#fff',
          linkHoverColor: '#fff',
          padding: '0',
          margin: '0',
        },
      ],
      {
        bgColor: '#fff',
        column_min_width: '100%',
        padding: '0',
        margin: '15px 0',
        selector:
          '.cmm-path-about_about-us #about .cmp-button-wrapper, .cmm-path-request-consultation #cmm-leave-a-review .cmp-text, .cmm-path-contact #cmm-leave-a-review .cmp-text',
        position: 'after',
      },
    ).then(() => {
      cmmSetupEventTracking([
        {
          selector: 'a.cmm-leave-a-review',
          action: 'Leave a Review - Amplify Button',
          event: 'click',
        },
      ]);
    });
  });
}

/* Text Us Buttons */
if (['request-consultation', 'contact'].includes(strPath)) {
  deferJQuery(function () {
    headerBannerMultipleColumns(
      [
        {
          text: "<div class='cmm-button-group'><a class='cmm-button cmm-button--size-small cmm-text-us' href='sms:+19786378669'>Text Us</a> <a class='cmm-button cmm-button--size-small cmm-leave-a-review' target='_blank' href='https://grow.creekmoremarketing.com/wti-inc--160458594150235/review-us?dashboard=1'>Leave a Review</a></div>",
          bgColor: '#fff',
          linkColor: '#fff',
          linkHoverColor: '#fff',
          padding: '0',
          margin: '0',
        },
      ],
      {
        bgColor: '#fff',
        column_min_width: '100%',
        padding: '0',
        margin: '0 0 15px',
        selector:
          '.cmm-path-request-consultation #cmm-leave-a-review .cmp-text, .cmm-path-contact #cmm-leave-a-review .cmp-text',
        position: 'after',
      },
    ).then(() => {
      cmmSetupEventTracking([
        {
          selector: 'a.cmm-leave-a-review',
          action: 'Leave a Review - Amplify Button',
          event: 'click',
        },
        {
          selector:
            '.cmm-path-request-consultation a.cmm-text-us[href="sms:+19786378669"]',
          action: 'Text (978) 637-8669 - Request a Consultation',
          event: 'click',
        },
        {
          selector: '.cmm-path-contact a.cmm-text-us[href="sms:+19786378669"]',
          action: 'Text (978) 637-8669 - Contact',
          event: 'click',
        },
      ]);
    });
  });
}

/* Site-Wide Footer */
var txtFooter =
  'We are a local window fashions dealer who offers custom curtains plus the full selection of Hunter Douglas custom window treatments, including plantation shutters, horizontal blinds, vertical blinds, roman shades, roller shades, honeycomb cellular shades, woven woods, sheer shadings, Pirouette shadings, and PowerView motorized blinds and shades. We proudly provide in-home shopping to the following areas in Massachusetts: Concord, Carlisle, Acton, Sudbury, Stow, Bedford, Littleton, Harvard, Groton, Wayland, Wellesley, Weston, Needham, Belmont, Chestnut Hill, Newton, Boxborough, Bolton, Lincoln, Westford, Winchester, Lexington, Arlington, Cambridge, and Charleston, MA.';
footerBlurb(txtFooter);

/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      text: 'Contact Us',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['desktop', 'laptop'],
      font: {
        family: 'AUTO',
      },
    },
    {
      mode: 'modal',
      icon: 'phone',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['tablet', 'mobile'],
    },
  ],

  modal_options: {
    header_text:
      '<img style="margin-top:10px;max-width:200px;" src="https://assets.hunterdouglas.com/content/dam/dealer-logos/w/wti-window-treatment-installation-1155395/64102320.png">',
    header_color: '#ffffff',
    description_text:
      'In the market for new window treatments? Look no further than WTI!',
    font: {
      family: 'AUTO',
    },
    buttons: [
      {
        title: '(978) 369-6165',
        link: 'tel:+19783696165',
        txt_color_hover: '#81A092',
        bg_color: '#81A092',
        class_list: ['call-us'],
        icon: 'phone',
      },
      {
        title: 'TEXT US',
        link: 'sms:+19786378669',
        txt_color_hover: '#81A092',
        bg_color: '#81A092',
        class_list: ['text-us'],
        icon: 'sms-solid',
      },
      {
        title: 'VISIT SHOWROOM',
        link: 'https://www.google.com/maps/place/WTI,+Inc./@42.4574266,-72.5153589,9z/data=!4m6!3m5!1s0x89e3909b7d70ffd9:0x65a7937497cf5403!8m2!3d42.4574266!4d-71.3947534!16s%2Fg%2F11bv1pgpyk',
        link_target: '_blank',
        txt_color_hover: '#81A092',
        bg_color: '#81A092',
        class_list: ['visit-showroom'],
        icon: 'map-pin',
      },
      {
        title: 'REQUEST A CONSULTATION',
        link: '/request-consultation',
        bg_color: '#81A092',
        txt_color_hover: '#81A092',
        class_list: ['request-consultation'],
        icon: 'email',
      },
    ],
    footer_text:
      'We are a full-service window treatment business that has been in the industry for over thirty years. Our expert staff has all of the knowledge and skills necessary to help you with your project from start to finish!',
    footer_color: '',
  },
}).then((_) => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us',
      action: 'Call (978) 369-6165 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .text-us',
      action: 'Text (978) 637-8669 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .visit-showroom',
      action: 'Visit Showroom - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .request-consultation',
      action: 'Request a Consultation - ConvertBoost©',
      event: 'click',
    },
  ]);
});

/* Custom Metadata */
cmmUpdateMetadata({
  'hunter-douglas/shades/sheer-shades': {
    t: 'Hunter Douglas Sheer Shades | WTI Window Treatment Installation',
    d: 'Find perfect sheer window shades from Hunter Douglas at WTI Window Treatment Installation near Concord, Carlisle, Acton, Bedford & Wayland, Massachusetts.',
  },
  'hunter-douglas/shades/cellular-shades': {
    t: 'Hunter Douglas Cellular Shades | WTI Window Treatment Installation',
    d: 'Upgrade your home with Hunter Douglas Honeycomb Shades at WTI Window Treatment Installation near Concord, Massachusetts.',
  },
  'hunter-douglas/shades/roman-shades': {
    t: 'Hunter Douglas Roman Shades | WTI Window Treatment Installation',
    d: 'Introduce Hunter Douglas Roman Shades to your home with WTI Window Treatment Installation',
  },
  'hunter-douglas/shades/roller-shades': {
    t: 'Hunter Douglas Roller Shades | WTI Window Treatment Installation',
    d: 'Find the perfect roller shades for your home at WTI Window Treatment Installation near Concord, MA',
  },
  'hunter-douglas/shades/woven-shades': {
    t: 'Hunter Douglas Woven Shades | WTI Window Treatment Installation',
    d: 'Woven Wood Shades, Bamboo Shades, and Bamboo Blinds from Hunter Douglas at WTI Window Treatment Installation.',
  },
  'hunter-douglas/shades/vertical-shades': {
    t: 'Vertical Shades | WTI Window Treatment Installation',
    d: 'Vertical Shades for Sliding Doors from Hunter Douglas at WTI Window Treatment Installation near Concord, Carlisle, Acton, Bedford & Wayland, Massachusetts.',
  },
  'hunter-douglas/shutters': {
    t: 'Hunter Douglas Plantation Shutters | WTI Window Treatment Installation',
    d: 'Introduce elegance and timeless style through our plantation shutters! Hunter Douglas window shutters available at WTI Window Treatment Installation.',
  },
  'hunter-douglas/blinds/vertical-blinds': {
    t: 'Hunter Douglas vertical Blinds | WTI Window Treatment Installation',
    d: 'Premium vertical blinds available at WTI Window Treatment Installation near Concord, Carlisle, Acton, Bedford & Wayland, Massachusetts.',
  },
  'hunter-douglas/blinds/wood-blinds': {
    t: 'Hunter Douglas Wood Blinds | WTI Window Treatment Installation',
    d: 'Premium wood window blinds available at WTI Window Treatment Installation near Concord, Carlisle, Acton, Bedford & Wayland, Massachusetts.',
  },
  'hunter-douglas/blinds/metal-blinds': {
    t: 'Hunter Douglas metal Blinds | WTI Window Treatment Installation',
    d: 'Premium aluminum blinds available at WTI Window Treatment Installation near Concord, Carlisle, Acton, Bedford & Wayland, Massachusetts.',
  },
  'hunter-douglas/drapery': {
    t: 'Hunter Douglas Drapery | WTI Window Treatment Installation',
    d: 'Drapery, Valance Curtains, and Living Room Curtains from Hunter Douglas at WTI Window Treatment Installation near Concord, Carlisle, Acton, Bedford & Wayland, Massachusetts.',
  },
  'hunter-douglas/powerview-automation': {
    t: 'Motorized Blinds, Automatic Blinds | WTI Window Treatment Installation',
    d: 'Modernize your home with motorized blinds. Raise and lower the with press of a button or voice command.',
  },
  'hunter-douglas/featured/room-darkening': {
    t: 'Room Darkening | WTI Window Treatment Installation',
    d: 'Find the perfect blackout curtains and shades for your home! Check out more at WTI Window Treatment Installation',
  },
  'hunter-douglas/featured/energy-efficient': {
    t: 'Energy Efficiency | WTI Window Treatment Installation',
    d: 'Create a more energy efficiency home with WTI Window Treatment Installation. Our products can help your home and lower your bill.',
  },
  'hunter-douglas/featured/light-enhancing': {
    t: 'Light Enhancing | WTI Window Treatment Installation',
    d: 'Perfectly control the light in your home. Using products from Hunter Douglas and WTI Window Treatment Installation',
  },
  'hunter-douglas/featured/door-coverings': {
    t: 'Door Covering | WTI Window Treatment Installation',
    d: 'Find the ideal door cover with Hunter Douglas! Products available at WTI Window Treatment Installation',
  },
  'hunter-douglas/featured/sound-absorption': {
    t: 'Sound Absorption | WTI Window Treatment Installation',
    d: 'Increase comfort in your home through our sound absorbent drapes and shades.',
  },
  'hunter-douglas/featured/top-down-bottom-up-shades': {
    t: 'Top-Down, Bottom-Up | WTI Window Treatment Installation',
    d: 'Perfect the privacy and light control in your home.',
  },
});
